import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=8a3703f6&"
import script from "./assignment.ts?vue&type=script&lang=ts&"
export * from "./assignment.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports